export default "__VITE_ASSET__5a106c93__"